var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 grid-margin"},[_c('div',{staticClass:"allyLoad text-center",style:({
      width: _vm.width ? _vm.width : '100px',
      height: _vm.height ? _vm.height : '100px',
      margin: _vm.margin ? _vm.margin : '100px 0px 0px 0px',
    })},[_c('hr'),_c('hr'),_c('hr'),_c('hr')])])}
var staticRenderFns = []

export { render, staticRenderFns }